import {
    DescContainer,
    FootballBackground,
    GroupAd,
    GroupAdWrapper,
    GroupDesc,
    GroupLink,
    SectionSubtitle,
} from "./FacebookGroup.styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { faFacebookSquare } from "@fortawesome/free-brands-svg-icons";
import { MAIN_COLOR } from "../../components/globalThemes";
import SectionContainer from "../../components/section-items/SectionContainer/SectionContainer";
import SectionTitle from "../../components/section-items/SectionTitle/SectionTitle";
import SectionText from "../../components/section-items/SectionText/SectionText";
import Section from "../../components/section-items/Section/Section";
import "./FacebookGroup.css";
import { FACEBOOK_PAGE } from "../../utils/info";

const FacebookGroup = () => {
    return (
        <Section theme={"light"}>
            <GroupAdWrapper>
                <GroupAd href={FACEBOOK_PAGE} target={"_blank"}>
                    <FontAwesomeIcon
                        icon={faFacebookSquare}
                        color={MAIN_COLOR}
                        className={"icon-style"}
                    />
                    <DescContainer>
                        <GroupLink>{"Facebook"}</GroupLink>
                        <GroupDesc>
                            {
                                "Dołącz do naszej społeczności kibiców.\nDziękujemy za wsparcie oraz zaangażowanie!"
                            }
                        </GroupDesc>
                    </DescContainer>
                </GroupAd>
            </GroupAdWrapper>
            <SectionContainer style={{ flex: 1 }}>
                <SectionTitle>{"OFICJALNY FANPAGE"}</SectionTitle>
                <SectionText>
                    {
                        "Obserwuj naszą oficjalną stronę na Facebooku. Znajdują się tam relacje z meczy oraz wszelkie informacje związane z klubem. Na grupie znajdziesz również informacje na temat nadchodzących spotkań oraz zdjęcia z poszczególnych wydarzeń. Grupa na Facebooku jest główną formą kontaktu z naszymi kibicami.\nNie czekaj - dołącz do nas!"
                    }
                </SectionText>
                <SectionSubtitle>
                    {"OBSERWUJ · KIBICUJ · WSPIERAJ"}
                </SectionSubtitle>
            </SectionContainer>
            <FootballBackground src={"/ball.png"} />
        </Section>
    );
};

export default FacebookGroup;
